// CreateSocietyAdmin.jsx
import React, { useEffect, useState } from "react";
import { submitAdmin } from "./APIs/CreateSocietyApi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL } from "./APIs/config";
import axios from "axios";
import Sidebar from "./Sidebar";
import Header from "./Header";
import { FiUserPlus, FiChevronDown } from "react-icons/fi";

const CreateSocietyAdmin = () => {
  const [errors, setErrors] = useState({});
  const [societies, setSocieties] = useState([]);
  const [selectedSociety, setSelectedSociety] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordRules, setPasswordRules] = useState({
  length: false,
  firstCapital: false,
  secondSmall: false,
  number: false,
  special: false,
});

  const [formData, setFormData] = useState({
    adminName: "", societyMember: "", adminEmail: "", createPassword: "",
    adminPhoneNo: "", societyRegistration: "", society: "",
  });

  const validateForm = () => {
    const newErrors = {};
    if (!formData.adminName) newErrors.adminName = "Required";
    if (!formData.society) newErrors.society = "Required";
    if (!formData.societyMember) newErrors.societyMember = "Required";
    if (!formData.societyRegistration) newErrors.societyRegistration = "Required";
    if (!formData.adminEmail || !formData.adminEmail.includes("@")) newErrors.adminEmail = "Invalid email";
    // if (!/^(?=.*[A-Za-z])(?=.*\d)(?=.*@).{8,}$/.test(formData.createPassword)) newErrors.createPassword = "8+ chars, letter, number, @ required";
    if (
  !/^[A-Z]/.test(formData.createPassword) ||                // First capital
  !/[a-z]/.test(formData.createPassword[1]) ||              // Second small
  !/\d/.test(formData.createPassword) ||                   // Number
  !/[^A-Za-z0-9]/.test(formData.createPassword) ||         // Special char
  formData.createPassword.length > 6 ||                    // Max length 6
  formData.createPassword.length < 2                       // Minimum safety
) {
  newErrors.createPassword = "Invalid password format";
}
    if (!/^\d{10,15}$/.test(formData.adminPhoneNo)) newErrors.adminPhoneNo = "Invalid phone";

    setErrors(newErrors);
    return newErrors;
  };

  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => ({ ...prev, [name]: value }));
  // };

  const handleInputChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({ ...prev, [name]: value }));

  if (name === "createPassword") {
    setPasswordRules({
      length: value.length <= 6 && value.length > 0,
      firstCapital: /^[A-Z]/.test(value),
      secondSmall: value.length > 1 ? /[a-z]/.test(value[1]) : false,
      number: /\d/.test(value),
      special: /[^A-Za-z0-9]/.test(value),
    });
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      toast.error("Please ensure all fields are valid.");
      return;
    }

    setLoading(true);
    try {
      const response = await submitAdmin(formData);
      const resultText = typeof response === "string" ? response : response?.data?.message || "";

      if (String(resultText).toLowerCase().includes("success")) {
        toast.success("Admin Created Successfully!");
        setFormData({
          adminName: "", societyMember: "", adminEmail: "", createPassword: "",
          adminPhoneNo: "", societyRegistration: "", society: "",
        });
        setSelectedSociety("");
      } else {
        toast.error("Failed to create admin.");
      }
    } catch (error) {
      toast.error("Server error.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSocieties();
  }, []);

  async function fetchSocieties() {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(`${BASE_URL}/api/get-society-details`, {
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      });
      setSocieties(response.data || []);
    } catch (error) {
      toast.error("Could not load societies.");
    }
  }

  const handleSocietyChange = (e) => {
    const selected = e.target.value;
    setSelectedSociety(selected);
    const selectedObj = societies.find((soc) => soc.societyName === selected);
    setFormData((prev) => ({
      ...prev,
      society: selectedObj?.societyName || "",
      societyRegistration: selectedObj?.societyRegistrationNo || prev.societyRegistration,
    }));
  };

  return (
    <div className="flex min-h-screen bg-bg-primary text-text-main font-satoshi transition-colors duration-300">
      <ToastContainer theme="dark" />
      <Sidebar />

      <div className="flex-1 flex flex-col h-screen overflow-hidden">
        <Header />

        <main className="flex-1 overflow-y-auto p-6 md:p-12 relative">
          <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
            <div className="absolute bottom-[-10%] right-[-10%] w-[600px] h-[600px] bg-green-900/5 rounded-full blur-[120px]"></div>
          </div>

          <div className="max-w-5xl mx-auto relative z-10">
            <div className="mb-10">
              <h1 className="text-3xl font-clash font-bold text-text-main flex items-center gap-3">
                New Administrator <FiUserPlus className="text-signal-orange" />
              </h1>
              <p className="text-text-muted mt-1">Grant system access to a society representative</p>
            </div>

            <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-8 bg-transparent">

              <div className="space-y-6">
                <div className="flex flex-col gap-1">
                  <label className="text-xs font-bold text-text-muted uppercase tracking-wider">Select Society *</label>
                  <div className="relative">
                    <select
                      name="society"
                      value={selectedSociety}
                      onChange={handleSocietyChange}
                      className="w-full bg-bg-input border border-border rounded px-4 py-3 text-text-main appearance-none focus:outline-none focus:border-signal-orange transition-colors"
                    >
                      <option value="" className="bg-bg-secondary">-- Select Society --</option>
                      {societies.map((s) => (
                        <option key={s.societyId} value={s.societyName} className="bg-bg-secondary">{s.societyName}</option>
                      ))}
                    </select>
                    <FiChevronDown className="absolute right-4 top-1/2 -translate-y-1/2 text-text-muted pointer-events-none" />
                  </div>
                  {errors.society && <span className="text-xs text-red-500">{errors.society}</span>}
                </div>

                <div className="flex flex-col gap-1">
                  <label className="text-xs font-bold text-text-muted uppercase tracking-wider">Admin Name *</label>
                  <input type="text" name="adminName" value={formData.adminName} onChange={handleInputChange} className="w-full bg-bg-input border border-border rounded px-4 py-3 text-text-main focus:outline-none focus:border-signal-orange transition-colors" />
                  {errors.adminName && <span className="text-xs text-red-500">{errors.adminName}</span>}
                </div>

                <div className="flex flex-col gap-1">
                  <label className="text-xs font-bold text-text-muted uppercase tracking-wider">Is Society Member? *</label>
                  <div className="flex gap-6 pt-2">
                    {['yes', 'no'].map(opt => (
                      <label key={opt} className="flex items-center gap-2 cursor-pointer group">
                        <div className={`w-5 h-5 rounded-full border flex items-center justify-center ${formData.societyMember === opt ? 'border-signal-orange' : 'border-border'}`}>
                          {formData.societyMember === opt && <div className="w-2.5 h-2.5 rounded-full bg-signal-orange"></div>}
                        </div>
                        <input type="radio" name="societyMember" value={opt} checked={formData.societyMember === opt} onChange={() => setFormData(p => ({ ...p, societyMember: opt }))} className="hidden" />
                        <span className="text-sm uppercase font-bold text-text-main group-hover:text-signal-orange transition-colors">{opt}</span>
                      </label>
                    ))}
                  </div>
                  {errors.societyMember && <span className="text-xs text-red-500">{errors.societyMember}</span>}
                </div>
              </div>

              <div className="space-y-6">
                
                <div className="flex flex-col gap-1">
                  <label className="text-xs font-bold text-text-muted uppercase tracking-wider">Society Reg. No</label>
                  <input type="text" name="societyRegistration" value={formData.societyRegistration} readOnly className="w-full bg-bg-input border border-border rounded px-4 py-3 text-text-muted cursor-not-allowed" />
                </div>

                <div className="flex flex-col gap-1">
                  <label className="text-xs font-bold text-text-muted uppercase tracking-wider">Email Address *</label>
                  <input type="email" name="adminEmail" value={formData.adminEmail} onChange={handleInputChange} className="w-full bg-bg-input border border-border rounded px-4 py-3 text-text-main focus:outline-none focus:border-signal-orange transition-colors" />
                  {errors.adminEmail && <span className="text-xs text-red-500">{errors.adminEmail}</span>}
                </div>

                <div className="flex flex-col gap-1">
                  <label className="text-xs font-bold text-text-muted uppercase tracking-wider">Phone Number *</label>
                  <input type="text" name="adminPhoneNo" value={formData.adminPhoneNo} onChange={handleInputChange} className="w-full bg-bg-input border border-border rounded px-4 py-3 text-text-main focus:outline-none focus:border-signal-orange transition-colors" />
                  {errors.adminPhoneNo && <span className="text-xs text-red-500">{errors.adminPhoneNo}</span>}
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="flex flex-col gap-1">
                    <label className="text-xs font-bold text-text-muted uppercase tracking-wider">Password *</label>
                    <input type="password" name="createPassword" value={formData.createPassword} onChange={handleInputChange} className="w-full bg-bg-input border border-border rounded px-4 py-3 text-text-main focus:outline-none focus:border-signal-orange transition-colors" />
                    {/* {errors.createPassword && <span className="text-xs text-red-500">Complex password required</span>} */}
                    {formData.createPassword && (
  <div className="text-xs space-y-1 mt-2">
    <p className={passwordRules.length ? "text-green-500" : "text-red-500"}>
      • Max 6 characters
    </p>
    <p className={passwordRules.firstCapital ? "text-green-500" : "text-red-500"}>
      • First letter should be Capital
    </p>
    <p className={passwordRules.secondSmall ? "text-green-500" : "text-red-500"}>
      • Second letter should be small
    </p>
    <p className={passwordRules.number ? "text-green-500" : "text-red-500"}>
      • Must include a number
    </p>
    <p className={passwordRules.special ? "text-green-500" : "text-red-500"}>
      • Must include a special character
    </p>
  </div>
)}
                  </div>
                  {/* <div className="flex flex-col gap-1">
                    <label className="text-xs font-bold text-text-muted uppercase tracking-wider">Secure PIN *</label>
                    <input type="text" name="createPin" value={formData.createPin} onChange={handleInputChange} className="w-full bg-bg-input border border-border rounded px-4 py-3 text-text-main focus:outline-none focus:border-signal-orange transition-colors" />
                    {errors.createPin && <span className="text-xs text-red-500 text-right">{errors.createPin}</span>}
                  </div> */}
                </div>
              </div>

              <div className="md:col-span-2 pt-8 border-t border-border text-right">
                <button type="submit" disabled={loading} className="px-8 py-3 bg-signal-orange text-noir-900 font-bold uppercase tracking-wide hover:bg-orange-400 transition-colors rounded shadow-lg shadow-orange-900/20 disabled:opacity-50">
                  {loading ? "Creating..." : "Create Administrator"}
                </button>
              </div>

            </form>
          </div>
        </main>
      </div>
    </div>
  );
};

export default CreateSocietyAdmin;
